import { useEffect } from 'react';
import { createConsumer } from '@rails/actioncable';

let cable;
let subscription;
const subscribers = new Map();
let manualPingInterval = null;

function getCable() {
  if (cable) return cable;

  // console.log("🔌 Creating ActionCable consumer");
  cable = createConsumer(window.CABLE_URL || '/cable');
  window.cable = cable

  cable.connection.monitor.constructor.staleThreshold = 45 * 1000

  // Start the built-in heartbeat monitor
  if (!cable.connection.monitor.isRunning()) {
    cable.connection.monitor.start();
  }


  // Set up subscription
  subscription = cable.subscriptions.create('LiveEventsChannel', {
    connected() {
      // console.log("✅ Connected to LiveEventsChannel");
    },

    disconnected() {
      // console.warn("❌ Disconnected from LiveEventsChannel");
    },

    received(payload) {
      const eventType = payload['event-type'];
      const eventData = payload['event-data'];

      const handlers = subscribers.get(eventType);
      
      if (handlers) {
        handlers.forEach((handler) => handler(eventData));
      }
    },
  });

  setInterval(() => {
    if (subscription && subscription.consumer && subscription.consumer.connection.isOpen()) {
      subscription.perform("touch");
    } else {
      console.log("⚠️ Skipping heartbeat: connection not open");
    }
  }, 30000);


  return cable;
}

export function subscribe(eventType, handler) {
  //console.log("Subscribe to", eventType, "with", handler)
  getCable()

  if (!subscribers.has(eventType)) {
    subscribers.set(eventType, new Set());
  }

  subscribers.get(eventType).add(handler);

  return () => {
    const set = subscribers.get(eventType);
    set?.delete(handler);
    if (set?.size === 0) {
      subscribers.delete(eventType);
    }
  };
}

export function useCableEvent(eventType, handler) {
  useEffect(() => {
    const unsubscribe = subscribe(eventType, handler);
    return () => unsubscribe();
  }, [eventType, handler]);
}
